export const isActiveLink = (href) => {
  return href !== '#' && window.location.href.indexOf(href) > 0
}
